import React from 'react'
import { createContext, useState } from "react";
import AuthContext from "./AuthContext";
import StatusContext from "./StatusContext";
import ClientContext from "./ClientContext";
import axios from "axios"

import { config } from '../config';
import { sortChats } from './StatusContext';


const ComprehensiveResponsesContext = createContext();

export default ComprehensiveResponsesContext;

export const ComprehensiveResponsesProvider = ((props) => {
    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const [promptsandresponses, setPromptsAndResponses] = useState([]);
    const [chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    const [confirmDelete, setConfirmDelete] = useState([])
    const [status, setStatus] = useState('');
    const [showdeletedialog, setShowDeleteDialog] = useState(false)
    const [showsavedialog, setShowSaveDialog] = useState(false)
    const [dialogboxtext, setDialogBoxText] = useState('')
    const [showProgressDialog, setShowProgressDialog] = useState(false)
    const [openDialogNewPrompt, setOpenDialogNewPrompt] = useState(false)
    
    const {
        currentUser,
        checkCurrentUser,
        checkServerCode,
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        temperature,
       
        changeLanguage,
        setIsLoading,
        isLoading,
        
        setShowLoginDialog,
        handleFocus,
        setWaitOnResponse,
        getAIProvider, 
        getAIModel,
        getAIName,
        responseMode,

    
    } = React.useContext(StatusContext);

    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);

    let totaltokens = 0
    let r = {}
    
    function extractTopics(text) {
       
        // Regular expressions for matching TOPIC, SUBTOPIC, and SUBSUBTOPIC
       
        const topicRegex = /@@(.*?)@@/g;
        const subtopicRegex = /!!!(.*?)!!!/g;
        const subsubtopicRegex = /%%(.*?)%%/g;

        // Extracting TOPICs
        const topics = [];
        let match;
        while ((match = topicRegex.exec(text)) !== null) {
            topics.push(match[1]); // match[1] contains the captured group
        }
    
        // Extracting SUBTOPICs
        const subtopics = [];
        while ((match = subtopicRegex.exec(text)) !== null) {
            subtopics.push(match[1]);
        }
    
        // Extracting SUBSUBTOPICs
        const subsubtopics = [];
        while ((match = subsubtopicRegex.exec(text)) !== null) {
            subsubtopics.push(match[1]);
        }
    
        return {
            topics,
            subtopics,
            subsubtopics
        };
    }

    
    const getComprehensiveResponses = async () => {
        let sortedChats  = []
        let chatsstatus = {
            chats: [],
            message:'',
            status: 200
        }

        //console.log("GetChats:", table, currentUser)
        setIsLoading(true)
        let q = "/deda_ai_api/comprehensiveresponses/get"
    
        try{
            const res = await axios.post(config.url.API_URL + q, {currentUser}) 
            if (res.data.length > 0) {
                const chats = res.data
                //console.log("getChats:", chats)
                sortedChats = sortChats(chats) 
            }
            else{
                // Handle case when res.data is empty
                console.log("There are no saved data.")
                chatsstatus = {chats: [], message:'There are no saved data.', status: 200}
            }
        } 
        catch(err)
        {
            console.log("Received error:", err)
            if (err.response && err.response.status !== 409)
            {
                chatsstatus.status = err.response.status
                chatsstatus = {chats: [], message:'', status: err.response.status}
                setIsLoading(false)
                return chatsstatus;
            }
        }
       
        setIsLoading(false)

        chatsstatus = {chats: sortedChats, message:'', status: 200}
       
        return chatsstatus;
    }

    const getTemplate = async (templateName) => {
        let template={}
        let getchatsstatus = {
            chats: [],
            status: 0
        }

        //console.log("getTemplate:", templateName)
        setIsLoading(true)
        let q = "/deda_ai_api/comprehensiveresponses/gettemplate"
    
        try{
            const res = await axios.post(config.url.API_URL + q, {currentUser, templateName}) 
            //console.log("ResData:", res.data)
            template = res.data 
        } 
        catch(err)
        {
            console.log("Received error:", err)
            if (err.response && err.response.status !== 409)
            {
                getchatsstatus.status = err.response.status
                setIsLoading(false)
                return getchatsstatus;
            }
        }
       
        setIsLoading(false)

        let chatsstatus = {template: template, status: 200}
       
        return chatsstatus;
    }
   
    const onClearChat = () => {

        setPromptsAndResponses([])
        setConfirmDelete([])
        setChatName('')
        setStatus('')
        setChatPrompt('')
    }

     const deleteChat = async (deletionChat) => {
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }
       
        setIsLoading(true)
        let chatname = deletionChat.chatname

        try{
            await axios.post(config.url.API_URL + "/deda_ai_api/comprehensiveresponses/delete", {currentUser, chatname}) 
            
            let chatsstatus = await getComprehensiveResponses()

            if (chatsstatus !== null)
            {
                setChatNames(chatsstatus.chats)
            }
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
        }

        setIsLoading(false)

    }


    const displayChat = (displayedChat) => {
        //console.log("DisplayChat:", displayedChat)

        onClearChat();

        setTimeout(() => {
            (async () => {
                // Get template
                let { template, status } = await getTemplate(displayedChat.chatname);

                if (status === 200) {
                     //fix prompts ids to match array indexes
                    let index = 0;
                    template.promptsandresponses.forEach((item) => {
                        item.id = index;
                        index++
                    })
                    setChatName(template.chatname);

                    setPromptsAndResponses(template.promptsandresponses);

                    var deletes = []
                    template.promptsandresponses.forEach((item) => {
                        let a = {
                            id: item.id,
                            state: false
                        }
                        deletes.push(a)
                    })
                    setConfirmDelete(deletes)
                    
                } else {
                    console.error("Failed to load template with status:", status);
                }
            })();
        }, 0);

    
    }

    const onDeletePrompt = (deletionChat) => {
        if (isLoading)
            return;
      
        let index = promptsandresponses.indexOf(deletionChat)

        let filteredChats = promptsandresponses.filter(chat => chat.id !== deletionChat.id)
        setPromptsAndResponses(filteredChats)

        let deleteconfirm = [...confirmDelete]

        deleteconfirm.splice(index, 1)
        setConfirmDelete(deleteconfirm)

    }

    const changeConfirmDelete = (prompt, flag) => {
        let a = [...confirmDelete]
        a.forEach((item) => {
            if (item.id === prompt.id)
                item.state = flag
        })

        setConfirmDelete(a)
    }

    const onSaveResponses = async () => {
        console.log("onSaveResponse")
       
        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

         if (chatNames.length > 1)
        {
            setStatusNavbar(changeLanguage('comprehensiveresponses', 'archivelimit'))
            return
        }

        for (let i = 0; i < chatNames.length; i++) {
            if (chatNames[i].chatname === chatName) {
                console.log("Here")
                let result = window.confirm(changeLanguage('tutor', 'sametopic'));
                if (!result)
                {
                    setIsLoading(false);
                    return;
                }
                else
                    break
            }
        }

        //id will be fixed on server side
        let newchat = {
                chatname: chatName,
                promptsandresponses: promptsandresponses,
        };
      
        let chat = JSON.stringify(newchat)
     
        setIsLoading(true);
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/comprehensiveresponses/save", { currentUser, chat }, {
                withCredentials: true
            })

            let chatsstatus = await getComprehensiveResponses()

            if (chatsstatus !== null)
            {
                setChatNames(chatsstatus.chats)
            }
        }
        catch (err) {
           
            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
         
        }

        setIsLoading(false);
       
    }

    const getSubtopics = async (request) => {
      
        setStatus('')

        let a = {}
      
        let i = 0;
        if (promptsandresponses.length) {
            i = promptsandresponses[promptsandresponses.length - 1].id + 1
        }

        let r = {
            id: i,
            prompt: chatPrompt,
            response: "",
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
       

        setPromptsAndResponses([...promptsandresponses, r])

        //ScrollResponse()
        if (promptsandresponses.length > 0)
            {
                setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
                handleFocus()
            }
        if (confirmDelete.length <= promptsandresponses.length) {
            let a = {
                id: i,
                state: false
            }
            setConfirmDelete([...confirmDelete, a])
        }
       

        let req = {
            user:currentUser,
            request: request,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }


        setIsLoading(true)
        try {
            let res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })
          
            let server_response = JSON.parse(res.data);

            updateCredits(server_response.tokens)

            a = extractTopics(server_response.data)

          
        } catch (err) {
          
            console.log("Error:", err)
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
          
        }
        setIsLoading(false)
        return a
        
    }



const processSingleSubtopic = async(topic, subtopic) =>  {

  totaltokens = 0
  
  let total = 0
  if (responseMode === '2')  //DETAILED mode
    total = 1
  else
    total = 1 + subtopic.subsubtopics.length

  let count = 0
 
  let j = 0
 
  setShowProgressDialog(true)

    count++

    if (responseMode === '3')  
        //setWaitOnResponse(`Preparing (${count} of ${total}): ${subtopic.subsubtopics[j].title}...`);
        setWaitOnResponse(`Preparing (${count} of ${total}): ${subtopic.subtopic}...`);
    else 
        setWaitOnResponse(`Preparing: ${subtopic.subtopic}...`);
    
    let s = `Tell me more about '${subtopic.subtopic}' in the context of '${topic}'. Return result with '${subtopic.subtopic}' as a title and format it with a Markdown format ##. `;
    let req = {
        user: currentUser,
        request: s,
        temperature: temperature,
        aiprovider: getAIProvider(),
        aimodel: getAIModel(),
        ainame: getAIName(),
    };
    
    let res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
        withCredentials: true
    });

    let server_response = JSON.parse(res.data);
    //console.log("Add response:", server_response.data);
    r.response += "\n" + server_response.data;
    totaltokens += server_response.tokens;

   

    ///////////////////////SUBSUBTOPICS

    
    if (responseMode === '3')  //COMPREHENSIVE  mode - subtopics and subsubtopics
    {
        count++
        setWaitOnResponse(`Preparing (${count} of ${total}): ${subtopic.subsubtopics[j].title}...`);
       
        s = `Tell me more about '${subtopic.subsubtopics[j].title}' in the context of '${topic}'. Return result with '${subtopic.subsubtopics[j].title}' as a subtitle and format it with a Markdown format ###.`;
        req = {
            user: currentUser,
            request: s,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        };
        
        res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
            withCredentials: true
        });
    

        server_response = JSON.parse(res.data);
        //console.log("Add response:", server_response.data);
        r.response += "\n" + server_response.data;
        subtopic.subsubtopics[j].content = r.response
        totaltokens += server_response.tokens;
        j++
       

        //console.log("Subtopic:", subtopic.subsubtopics[j].title);
        count++
        console.log("Count 2")
        setWaitOnResponse(`Preparing (${count} of ${total}): ${subtopic.subsubtopics[j].title}...`);
        s = `Tell me more about '${subtopic.subsubtopics[j].title}' in the context of '${topic}'. Return result with '${subtopic.subsubtopics[j].title}' as a subtitle and format it with a Markdown format ###.`;
        req = {
            user: currentUser,
            request: s,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        };
        
        res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
            withCredentials: true
        });

        server_response = JSON.parse(res.data);
        //console.log("Add response:", server_response.data);
        r.response += "\n" + server_response.data;
        subtopic.subsubtopics[j].content = r.response
        totaltokens += server_response.tokens;
        j++
       
    
        //console.log("Subtopic:", subtopic.subsubtopics[j].title);
        count++
        console.log("Count 3")
        setWaitOnResponse(`Preparing (${count} of ${total}): ${subtopic.subsubtopics[j].title}...`);
        s = `Tell me more about '${subtopic.subsubtopics[j].title}' in the context of '${topic}'. Return result with '${subtopic.subsubtopics[j].title}' as a subtitle and format it with a Markdown format ###.`;
        req = {
            user: currentUser,
            request: s,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        };
        
        res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
            withCredentials: true
        });

        server_response = JSON.parse(res.data);
        //console.log("Add response:", server_response.data);
        r.response += "\n" + server_response.data;
        subtopic.subsubtopics[j].content = r.response
        totaltokens += server_response.tokens;
        j++

     
        //console.log("Subtopic:", subtopic.subsubtopics[j].title);
        count++
        setWaitOnResponse(`Preparing (${count} of ${total}): ${subtopic.subsubtopics[j].title}...`);
        s = `Tell me more about '${subtopic.subsubtopics[j].title}' in the context of '${topic}'. Return result with '${subtopic.subsubtopics[j].title}' as a subtitle and format it with a Markdown format ###.`;
        req = {
            user: currentUser,
            request: s,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        };
        
        res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
            withCredentials: true
        });

        server_response = JSON.parse(res.data);
        //console.log("Add response:", server_response.data);
        r.response += "\n" + server_response.data;
        subtopic.subsubtopics[j].content = r.response
        totaltokens += server_response.tokens;
        j++

        //console.log("Subtopic:", subtopic.subsubtopics[j].title);
        count++
        setWaitOnResponse(`Preparing (${count} of ${total}): ${subtopic.subsubtopics[j].title}...`);
        s = `Tell me more about '${subtopic.subsubtopics[j].title}' in the context of '${topic}'. Return result with '${subtopic.subsubtopics[j].title}' as a subtitle and format it with a Markdown format ###. `;
        req = {
            user: currentUser,
            request: s,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        };
        
        res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
            withCredentials: true
        });

        server_response = JSON.parse(res.data);
        //.log("Add response:", server_response.data);
        r.response += "\n" + server_response.data;
        subtopic.subsubtopics[j].content = r.response
        totaltokens += server_response.tokens;
        j++
        
    }
   
    setShowProgressDialog(false)
}

const onSubmitChatNew = async () => {
    console.log("onsubmitchatnew:", chatPrompt)
   
    setStatus("")

    if (chatPrompt.length === 0) {
        setStatus(changeLanguage('status', 'promptempty'))
        return;
    }
    if (promptsandresponses.length)
    {
        setOpenDialogNewPrompt(true)
        return
    }

    onSubmitChat()
}

    const onSubmitChat = async () => {
        console.log("onSubmitChat 1:", chatPrompt)
    
        setStatus('')

        if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }
       
        
        if (chatPrompt.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }
        
        
        let request = `For the following topic give me 10 subtopics and for each subtopic generate 5 subsubtopics. Generate only titles without any additional result.
        Return result in the following format:
        @@<TOPIC>@@
        !!!1. Subtitl!!!
        %%1.1 Subsubtitle%%
        The Topic is: ${chatPrompt}.`

        let topic = await getSubtopics(request)


        /*
        let topic = {
            topics: ['Napoleon'],
            subtopics: [
                "1. Early Life and Education",
                "2. Rise to Power",
                "3. Napoleonic Wars",
                "4. Reforms and Policies",
                "5. Exile and Legacy",
            ],
            
            subsubtopics: [
                "1.1 Childhood in Corsica",
                "1.2 Military Education in France",
                "1.3 Influence of the French Revolution",
                "2.1 The Siege of Toulon",
                "2.2 The Italian Campaigns",
                "2.3 Coup of 18 Brumaire",
                "3.1 The War of the Third Coalition",
                "3.2 The Peninsular War",
                "3.3 The Invasion of Russia",
                "4.1 Napoleonic Code",
                "4.2 Educational Reforms",
                "4.3 Economic Policies and the Bank of France",
                "5.1 First Exile to Elb",
                "5.2 The Hundred Days and Waterloo",
                "5.3 Impact on Europe and Modern Warfare",
            ]
        
        }
        */
      
        //console.log("SUBTOPICS_1:", topic)

      
        let index = 0
        if (promptsandresponses.length)
            index = promptsandresponses[promptsandresponses.length - 1].id + 1
      

        let a = {
            id: index,
            prompt: chatPrompt,
            type: 'Response',
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
            response: []
        }

        if (Array.isArray(topic.subtopics)) {
           
            let j = 0;
            let k = 0
            while (j < topic.subtopics.length) {
             
                let r = {
                    id: j,
                    subtopic: topic.subtopics[j],
                    subsubtopics: [],
                    response: '',
                    showresponse: false,
                };
        
                
                // Push subsubtopics based on the available data
                for (let l = k; l < k + 5; l++) { // Assuming you want to limit to 5 subsubtopics
                    if (topic.subsubtopics[l]) { // Check if the subsubtopic exists
                        r.subsubtopics.push({
                            title: topic.subsubtopics[l] || '', // Safely access title
                            content:  '' // Safely access content
                        });
                    }
                }
                k += 5
                a.response.push(r)        
                j++;
            }
        }
     
        let d = []
        let b = {
            id: a.id,
            state: false
        }
        d.push(b)
        setConfirmDelete([...d])

        setWaitOnResponse('')
        setPromptsAndResponses([a])
        
    }

    const onRequestSubtopic = async (index, topic, subtopic) => {

        r.response = ''
      
       try
        {
            await processSingleSubtopic(topic, subtopic)
    
            // You can put any logic here that needs to run after all subtopics have been processed
            console.log("Subtopic processed.");

            let temprpomptsandresponses= [...promptsandresponses]
            subtopic.response = r.response
          
            subtopic.showresponse = true;
            temprpomptsandresponses[index].response[subtopic.id] = subtopic
        
            updateCredits(totaltokens)

        }
        catch (err)  {
            setStatus("Something went wrong. Please try again.")
        }
         setWaitOnResponse('')
    }

    const onDisplaySubtopic = (index, subtopic, display) => {
        let temprpomptsandresponses = [...promptsandresponses]

        temprpomptsandresponses[index].response[subtopic.id].showresponse = display
        setPromptsAndResponses(temprpomptsandresponses)

    }


    

    const onResubmitChat = (prompt) => {
        console.log("onResubmitQuestion:", prompt)
        let text = ''
        SendRequest(prompt.prompt, text, false)
    }

   
    async function SendRequest(request, task, combinerequestandtask) {
        console.log("Comprehensive:", getAIProvider())
    
       
        setStatus('')
     
        if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }
       
        if (request.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }

        if (getAIProvider() === 'DeepSeek')
        {
            setStatus(changeLanguage('status', 'deepseeknotsupported'))
            return;
        }

        let i = 0;
        if (promptsandresponses.length) {
            i = promptsandresponses[promptsandresponses.length - 1].id + 1
        }

        let r = {
            id: i,
            prompt: request,
            response: "",
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
        if (combinerequestandtask)
        {
            r.prompt = task + request
        }

        setPromptsAndResponses([...promptsandresponses, r])

        //ScrollResponse()
        if (promptsandresponses.length > 0)
            {
                setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
                handleFocus()
            }
        if (confirmDelete.length <= promptsandresponses.length) {
            let a = {
                id: i,
                state: false
            }
            setConfirmDelete([...confirmDelete, a])
        }
        let rqst = task + request

        setChatPrompt('')
      

        let req = {
            user:currentUser,
            request: rqst,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

        setIsLoading(true)
        try {
            let res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })
          

            let server_response = JSON.parse(res.data);

            updateCredits(server_response.tokens)

            let a = extractTopics(server_response.data)

            let response = '';
            let totaltokens = 0
            //get ABOUT TOPIC
            
            let s = `Tell me more about: + ${a.topics}`
            req = {
                user:currentUser,
                request: s,
                temperature: temperature,
                aiprovider: getAIProvider(),
                aimodel: getAIModel(),
                ainame: getAIName(),
            }
            res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })
          
            server_response = JSON.parse(res.data);
            response += server_response.data
            totaltokens = server_response.tokens

            //get ABOUT SUBTOPICS
            setWaitOnResponse('Waiting for Subtopics description...')
            
            console.log("Before")
            a.subtopics.forEach(async (item)=>{
               
                setWaitOnResponse(`Waiting on ${item}...`)
                let s = `Tell me more about ${item} in the contet of ${a.topics}`
                    req = {
                        user:currentUser,
                        request: s,
                        temperature: temperature,
                        aiprovider: getAIProvider(),
                        aimodel: getAIModel(),
                        ainame: getAIName(),
                    }
                res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                    withCredentials: true
                    })

                server_response = JSON.parse(res.data);
                console.log("Subtopic response:", server_response.data)
                response += server_response.data
                totaltokens = server_response.tokens
            })
            console.log("After")

            if (promptsandresponses.length) {
                i = promptsandresponses[promptsandresponses.length - 1].id + 1
            } else i = 0
            r = {
                id: i,
                prompt: a.topics,
                response: response,
                aiprovider: getAIProvider(),
                aimodel: getAIModel(),
                ainame: getAIName(),
            }
            setPromptsAndResponses([...promptsandresponses, r])
            console.log("PromptsandResponses:", promptsandresponses)
            //ScrollResponse()
            //handleFocus()
            setWaitOnResponse('')
            updateCredits(totaltokens)

        } catch (err) {
          
            console.log("Error:", err)
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
            setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
        }
        setIsLoading(false)
    }

    
    

    return <ComprehensiveResponsesContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse,
        promptsandresponses,
        chatName,
        chatNames,
        setChatName,
        setChatNames,
      
        onSubmitChatNew,
        onSubmitChat,
        
        onClearChat,
        onSaveResponses,
        deleteChat,
        displayChat,
        onDeletePrompt,
        changeConfirmDelete,
        confirmDelete,
        
        status,
        setStatus,
      
        showdeletedialog, 
        setShowDeleteDialog,
        showsavedialog, 
        setShowSaveDialog,
        setDialogBoxText,
        dialogboxtext,

        onResubmitChat,

        showProgressDialog, 
        setShowProgressDialog,

        onRequestSubtopic,
        onDisplaySubtopic,

        getComprehensiveResponses,
        getTemplate,

        openDialogNewPrompt,
        setOpenDialogNewPrompt,

    }}>
        {props.children}
    </ComprehensiveResponsesContext.Provider>
})